import { OffsetDateTime } from "@js-joda/core";
import BloodGlucoseClassification from "./BloodGlucoseClassification";

export type BloodGlucoseReading = {
  id: string;
  patientId: string;
  dateTime: OffsetDateTime;
  bloodGlucoseInMilligramsPerDeciliter: number;
  classification: BloodGlucoseClassification;
};

export type BloodGlucoseReadingApiDto = {
  id: string;
  patientId: string;
  dateTime: string;
  bloodGlucoseInMilligramsPerDeciliter: number;
  classification: BloodGlucoseClassification;
};

export const toBloodGlucoseReading = (dto: BloodGlucoseReadingApiDto): BloodGlucoseReading => ({
  ...dto,
  dateTime: OffsetDateTime.parse(dto.dateTime),
});
